import React from "react";
import { ReactComponent as MonitorO } from "../../../icons/MonitorImg.svg";
import { ReactComponent as NewLog } from "../../../icons/NewLog.svg";
import NewDateRangemonitor from "./MonitorActivityLog";
import { requestLog, checkStatus } from "./_redux/monitorCrud";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

class MonitorLog extends React.Component {
  constructor(props) {
    super(props);
    this.myRefMonitorLog = React.createRef();
    this.state = {
      requestLogMsg: null,
      downloadLogloading: false,
      open: false
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props && this.props.monitor !== null) {
      this.setState({
        ...this.state,
        loading: false
      });
    }
    if (prevProps !== this.props && this.props.status === false) {
      this.setState({
        ...this.state,
        loading: false,
        error: this.props.error
      });
    }
  }

  requestLog() {
    this.setState({
      ...this.state,
      requestLogMsg: null,
      downloadLogloading: true
    });
    requestLog(this.props.monitor.id)
      .then((res) => {
        if (res.data.status === true) {
          this.logRequestCheck(this.props.monitor.id);
        } else {
          this.setState({
            ...this.state,
            requestLogMsg: res.data.message,
            downloadLogloading: false,
            open: true
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status !== 404 && error) {
            this.setState({
              ...this.state,
              requestLogMsg: error.response.data.message,
              downloadLogloading: false,
              open: true
            });
          } else {
            this.props.history.push("error/error-v1");
          }
        } else {
          this.setState({
            ...this.state,
            requestLogMsg: error.message,
            downloadLogloading: false,
            open: true
          });
        }
      });
  }

  timerLog;
  logRequestCheck(id) {
    let check = true;
    if (check === true) {
      this.timerLog = setInterval(() => {
        checkStatus(id)
          .then((res) => {
            if (res.data.status === true) {
              let data = res.data.data;
              if (data[0].upload_request === "") {
                clearInterval(this.timerLog);
                this.myRefMonitorLog.current.childMethod();
                this.setState({
                  downloadLogloading: false
                });
              }
            } else {
              clearInterval(this.timerLog);
              this.setState({
                ...this.state,
                requestLogMsg: res.data.message,
                downloadLogloading: false,
                open: true
              });
            }
          })
          .catch((error) => {
            clearInterval(this.timerLog);
            if (error.response) {
              if (error.response.status !== 404 && error) {
                this.setState({
                  ...this.state,
                  requestLogMsg: error.response.data.message,
                  downloadLogloading: false,
                  open: true
                });
              } else {
                this.props.history.push("error/error-v1");
              }
            } else {
              this.setState({
                ...this.state,
                requestLogMsg: error.message,
                downloadLogloading: false,
                open: true
              });
            }
          });
      }, 6000);
    }
  }

  handleClose = () => this.setState({ open: false });

  render() {
    const { open } = this.state;
    return (
      <div className="row moni-details">
        <div className="col-sm-12 bordercss">
          <div className="monitor-box">
            <p>
              {" "}
              <MonitorO /> Monitor Activity Log
            </p>
          </div>
          <div className="btn-box-log">
            <p
              className="getnewLog"
              id="getnewLog"
              onClick={() => {
                this.requestLog(this.props.monitor.id);
              }}
            >
              <NewLog />
              New log
              {this.state.downloadLogloading && (
                <span
                  className="ml-3 spinner spinner-dark"
                  style={{ marginRight: "20px" }}
                ></span>
              )}
            </p>
            {this.state.requestLogMsg !== null ? (
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                open={open}
                onClose={this.handleClose}
                autoHideDuration={6000}
              >
                <MuiAlert
                  onClose={this.handleClose}
                  severity="error"
                  elevation={6}
                  variant="filled"
                  className="error"
                >
                  {this.state.requestLogMsg}
                </MuiAlert>
              </Snackbar>
            ) : null}
          </div>
        </div>
        <div className="col-sm-12">
          <NewDateRangemonitor
            monitor={this.props.monitor}
            ref={this.myRefMonitorLog}
          ></NewDateRangemonitor>
        </div>
      </div>
    );
  }
}

export default MonitorLog;
